export default __webpack_public_path__ + "static/UniversLTStd-Cn-ce1925fc00e2c3fc17f8e7619eb60bc3.ttf";